<template>
  <nuxt-link
    class="c-link-card t-link"
    :class="{
      'c-link-card--image': hasImage
    }"
    :to="url"
    :title="title"
    :aria-label="title"
    v-bind="$attrs"
  >
    <template v-if="backgroundImage.src">
      <nuxt-img
        class="c-link-card__image"
        v-bind="$getImgOptions(backgroundImage, {
          format: 'webp',
          alt: 'Image'
        })"
      />
      <span :class="imageTitleClass">{{ title }}</span>
    </template>
    <span
      v-else
      :class="titleClass"
    >{{ title }}</span>
  </nuxt-link>
</template>
<script>
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  mixins: [ UrlFilters ],
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    backgroundImage: {
      type: Object,
      default: () => ({})
    },
    bold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasImage() {
      const backgroundImage = this.backgroundImage
      return !!(backgroundImage && backgroundImage.src)
    },
    titleClass() {
      let result = ['t-heading-8', 'c-link-card__title', 'u-margin-bottom-xx-small'];

      if (this.bold) {
        result.push('c-link-card__title--bold');
      }

      return result;
    },
    imageTitleClass() {
      let result = ['c-link-card__image-title'];

      if (this.bold) {
        result.push('c-link-card__title--bold');
      }

      if (this.backgroundImage.src) {
        result.push('c-link-card__title--white');
      }

      return result;
    },
  }
}
</script>
<style lang="scss" scoped>
.c-link-card {
  display: inline-flex;
  margin-bottom: rem(10px);
  position: relative;
  width: 100%;

  &__title {
    font-weight: 400;
    text-transform: none;
    border-bottom: 2px solid transparent;
    &:hover {
      @include themify($themes) {
        border-bottom-color: themed('accent')
      }
    }
  }

  &__image {
    max-width: 100%;
  }

  &__image-title {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: rem(5px) rem(10px);
  }

  &__title--bold {
    font-weight: $font-weight-bold;
  }

  &__title--white {
    @include themify($themes) {
      color: themed('foreground', 'white-text');
    }
  }
}
</style>
